import React from "react";
import { useDispatch, useSelector } from "types/store";
import { getIsDatasetsLoading, getIsTableauMode } from "containers/App/reducer";
import { getDatasetViewMode } from "containers/View/reducer";
import { getHideShowMoreDatasets } from "containers/Pagination/reducer";
import SenseDataHeader from "components/Tiles/Sense/SenseDataHeader";
import SenseTileList from "components/Tiles/Sense/SenseTileList";
import { fetchNextDatasets } from "containers/Home/reducer";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { isEnabled } from "utils/featureFlags";
import DatasetList from "components/Tiles/Sense/DatasetList";
import styles from "./style.module.css";
import TableView from "@/components/Tiles/Sense/TableView/TableView";
const Sense = () => {
    const dispatch = useDispatch();
    const isTableauMode = useSelector(getIsTableauMode);
    const datasetViewMode = useSelector(getDatasetViewMode);
    const isDatasetsLoading = useSelector(getIsDatasetsLoading);
    const hideShowMore = useSelector((state) => getHideShowMoreDatasets(state));
    return (React.createElement("div", { className: styles.sense },
        React.createElement(SenseDataHeader, null),
        datasetViewMode === "TILE" && React.createElement(SenseTileList, null),
        datasetViewMode === "LIST" && isEnabled("data-list-view") && React.createElement(TableView, null),
        datasetViewMode === "LIST" && !isEnabled("data-list-view") && React.createElement(DatasetList, null),
        isTableauMode !== true && !hideShowMore && (React.createElement("div", { className: styles.showMore },
            !isDatasetsLoading && (React.createElement("div", null,
                React.createElement("a", { onClick: () => dispatch(fetchNextDatasets(undefined, undefined, undefined, undefined, true)) }, "Show More"))),
            isDatasetsLoading && (React.createElement("div", { className: styles.lHolder, style: isEnabled("agent-autonomy-controls") ? { top: "-40px" } : undefined },
                React.createElement(LoadingIndicator, { style: { margin: "0px" } })))))));
};
export default Sense;
